<template>
  <div class="auth-settings">
    <mk-button-biz
      class="auth-settings-btn"
      type="text"
      with="300px"
      @click="handleSkipUrlClick"
    >
      点击跳转权限设置
    </mk-button-biz>
  </div>
</template>

<script>
export default {
  name: 'AuthSettings',
  mounted () {
    this.handleSkipUrlClick()
  },
  methods: {
    handleSkipUrlClick () {
      // 拼接跳转参数
      const { password: sign, name } = JSON.parse(
        window.localStorage.getItem('account')
      )
      const { roleId } = JSON.parse(window.localStorage.getItem('user'))
      // 环境变量区分跳转生产环境还是测试环境
      let settingUrl = this.$env.VUE_APP_WP_BASE_URL
      const crmUrl = this.$MKSDK.config.oem.crmUrl
      if (crmUrl) {
        settingUrl = `//${crmUrl}`
      }
      const url = `${settingUrl}/#/login?adminExten=${name}&sign=${sign}&loginType=marketing&roleId=${roleId}`
      window.open(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.auth-settings-btn {
  margin-left: 20px;
  margin-top: 20px;
}
</style>
